const logo = document.querySelector('.logo')

if (logo) {
	const text = logo.textContent

	logo.innerHTML = [...text].map(letter => `<span>${letter}</span>`).join('')

	const letters = [...logo.querySelectorAll('span')]

function updateLogo(x) {
	const rect = logo.getBoundingClientRect()
	const maxDist = rect.width / 2

	letters.forEach(letter => {
		const r = letter.getBoundingClientRect()
		const t = Math.min(Math.abs(x - (r.left + r.width / 2)) / maxDist, 1)
		letter.style.fontWeight = Math.round(100 + t * 800)
	})
}

function resetLogo() {
	letters.forEach(letter => {
		letter.style.fontWeight = 900
	})
}

function bindGyro() {
	window.addEventListener('deviceorientation', e => {
		if (e.gamma == null) return

		const rect = logo.getBoundingClientRect()
		const gamma = Math.max(-45, Math.min(45, e.gamma))
		const x = rect.left + ((gamma + 45) / 90) * rect.width

		updateLogo(x)
	}, { passive: true })
}

logo.addEventListener('mousemove', e => updateLogo(e.clientX))
logo.addEventListener('mouseleave', resetLogo)

logo.addEventListener('touchmove', e => {
	if (e.touches[0]) updateLogo(e.touches[0].clientX)
}, { passive: true })

logo.addEventListener('touchend', resetLogo)

	if (typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission !== 'function') {
		bindGyro()
	}
}
